exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".total-by-year[data-v-6bd86dc9]{color:#3c47d1}.data-center[data-v-6bd86dc9]{text-align:center}.production[data-v-6bd86dc9]{background-color:#eee}.total[data-v-6bd86dc9]{color:#3c47d1!important}tr.total[key^=total-][data-v-6bd86dc9]{color:#3c47d1}tr.total[data-v-6bd86dc9]{color:#3c47d1!important}div.v-item-group.theme--light.v-expansion-panels.v-expansion-panels--accordion.v-expansion-panels--flat>div>button[data-v-6bd86dc9]{padding-left:0!important;padding-right:0!important}a[data-v-6bd86dc9]{color:#00e;text-decoration:underline}", ""]);

// exports
